import { render } from "./PrivacyPolicies.vue?vue&type=template&id=3c657ed1&scoped=true"
const script = {}

import "./PrivacyPolicies.vue?vue&type=style&index=0&id=3c657ed1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c657ed1"]])

export default __exports__